import { getCurrentInstance } from 'vue';
import { parseAPIErrorResponse } from 'dashboard/store/utils/api';
import { emitter } from 'shared/helpers/mitt';

/**
 * Custom hook to track events
 * @returns {Function} The track function
 */
export const useTrack = () => {
  const vm = getCurrentInstance();
  if (!vm) throw new Error('must be called in setup');

  return vm.proxy.$track;
};

/**
 * Emits a toast message event using a global emitter.
 * @param {string} message - The message to be displayed in the toast.
 * @param {Object|null} action - Optional callback function or object to execute.
 * @param {Object} options - Optional toast options.
 */
export const useAlert = (message, action = null, options = {}) => {
  const { duration, ...rest } = options;
  emitter.emit('newToastMessage', { message, action, duration, ...rest });
};

export const useAPIErrorAlert = (
  error,
  fallbackMessage,
  action = null,
  options = {}
) => {
  const message = parseAPIErrorResponse(error) || fallbackMessage;
  useAlert(message, action, options);
  return message;
};
